module.exports = __webpack_public_path__ + "static/media/callistoprotocoll.d2004f77.jpg";